export default defineNuxtPlugin(() => {
  const { $pinia } = useNuxtApp();
  const cookieYesStore = useCookieYesStore($pinia);

  document.addEventListener('cookieyes_banner_load', (eventData: any): void => {
    cookieYesStore.HANDLE_COOKIE_YES_LOAD(eventData);
  });

  document.addEventListener(
    'cookieyes_consent_update',
    (eventData: any): void => {
      cookieYesStore.HANDLE_COOKIE_YES_UPDATE(eventData);
    }
  );
});
